<template>
  <login-layout>
    <h1 slot="title" class="black--text my-3">
      {{ $t('CONFIGURAR NUEVA CONTRASEÑA') }}
    </h1>
    <template slot="content">
      <reset-new-password-form></reset-new-password-form>
    </template>
  </login-layout>
</template>

<script>
import ResetNewPasswordForm from '../components/ResetNewPasswordForm';
import LoginLayout from '../components/LoginLayout.vue';

export default {
  components: {
    ResetNewPasswordForm,
    LoginLayout,
  },
};
</script>

<style></style>
